// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup-inner-content .popup-content-header[data-v-5e568fec]{margin-bottom:16px}.popup-inner-content .popup-warning[data-v-5e568fec]{color:#ff223e}.popup-inner-content .popup-content-description[data-v-5e568fec]{font-weight:400;font-size:14px;line-height:17px;text-align:center;color:#858f9b;text-transform:uppercase}.popup-inner-content .popup-select-box[data-v-5e568fec]{margin-top:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
